import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButton from "../../../../components/BackButton";
import SpinnerLoader from "../../../../components/SpinnerLoader";
import {
  downloadDescriptionFile,
  updateLearnerApplicationStatus,
} from "../../../../redux/slices/learner.applications.slice";
import { RootState, useAppDispatch } from "../../../../redux/store";
import SaveConfirmModal from "../../../../components/modal/SaveConfirmModal";
import EventDetailsModal from "../../../Sessions/components/EventDetailsModal";
import {
  getHRApplications,
  updateHRApplicationStatus,
} from "../../../../redux/slices/hr.applications.slice";
import { FaEllipsisH } from "react-icons/fa";
import SearchWithFilter from "../../../../components/SearchWithFilter";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../../../components/LanguageSelector";
import TabNavbar from "../../../../components/Tabbar";
import { HR_TABS } from "../../../../utils/TabbarData";
import { showToast } from "../../../../utils/showToast";
function CourseApplications() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const STATUS_MAP: any = {
    APPLIED: t("Not Confirmed by Manager Yet"),
    APPROVED_BY_MANAGER: t("MANAGER APPROVED"),
    WAITING: t("WAITING LIST"),
    DRAFTED: t("DRAFTED"),
    CONFIRMED_BY_LEARNER: t("CONFIRMED BY LEARNER"),
    CONFIRMED_BY_HR: t("SEAT CONFIRMED"),
    CONFIRMED_BY_MANAGER: t("CONFIRMED BY MANAGER"),
    APPLICATION_REJECTED_BY_LEARNER: t("USER DECLINED"),
    HR_APPROVAL_PENDING: t("HR APPROVAL PENDING"),
    APPROVED_BY_HR: t("HR APPROVED"),
    ELIGIBLE: t("Eligible"),
    NOT_ELIGIBLE: t("Not Eligible"),
  };

  const PRORITY_MAP: any = {
    NOT_SET: t("Not Set"),
    HIGH: t("High"),
    TOP: t("Top"),
  };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    loading,
    appliedHRCourses,
    selectedCourseData,
    applidCourseMetaData,
    updateLoading,
  } = useSelector((state: RootState) => state.hrApplications) as any;

  const [modalData, setModalData] = useState<any[]>([]); // Modal data for events
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState<number | null>(null); // Track which menu is open
  const [filteredCourses, setFilteredCourses] =
    useState<any[]>(appliedHRCourses);
  const [searchTerm, setSearchTerm] = useState("");
  const menuRef = useRef<HTMLDivElement | null>(null); // Reference for Menu Modal
  const confirmationRef = useRef<HTMLDivElement | null>(null); // Reference for Confirmation Modal
  const [confirmationMenu, setConfirmationMenu] = useState<{
    action: string;
    item: any;
  } | null>(null);
  const [_confirmationMenu, _setConfirmationMenu] = useState<any | null>(null);
  const [selectedApplications, setSelectedApplications] = useState<any[]>([]);
  const menuMobileRef = useRef<HTMLDivElement | null>(null); // Reference for Menu Modal
  const confirmationMobileRef = useRef<HTMLDivElement | null>(null); // Reference for Confirmation Modal
  const [dropdownValue, setDropdownValue] = useState<any>("SELECT_AN_OPTION");
  const [dropdownEnabled, setDropdownEnabled] = useState(false); // Dropdown enable state
  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [isDownloading, setIsDownloading] = useState(false);
  // Close modals when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        (menuRef.current && menuRef.current.contains(event.target as Node)) ||
        (menuMobileRef.current &&
          menuMobileRef.current.contains(event.target as Node)) ||
        (confirmationRef.current &&
          confirmationRef.current.contains(event.target as Node)) ||
        (confirmationMobileRef.current &&
          confirmationMobileRef.current.contains(event.target as Node))
      ) {
        return; // Don't close if clicking inside a modal or menu
      }

      // Close modals and menus if clicking outside
      setMenuOpen(null);
      setConfirmationMenu(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedApplications.length > 0) {
      setDropdownEnabled(true); // Enable dropdown when at least one item is selected
    } else {
      setDropdownEnabled(false);
    }
  }, [selectedApplications]);

  const handleMenuClick = (index: number) => {
    setMenuOpen(menuOpen === index ? null : index); // Toggle menu open/close
  };

  const handleOptionSelect = (action: string, item: any) => {
    setMenuOpen(null); // Close menu
    setConfirmationMenu({ action, item }); // Open confirmation menu
  };
  const { id } = useParams();

  const handleConfirmation = async (confirm: boolean) => {
    if (confirm && confirmationMenu) {
      const { action, item } = confirmationMenu;

      const dataToSend: any = {
        course_id: item.course_id,
        user_id: item.user_id,
      };
      // Example: Call Redux API based on action
      if (action === "REMOVE_PRIORITY") {
        dataToSend.application_status = "WAITING";
        dataToSend.priority = "NOT_SET";
      } else if (action === "PRIORITIZE_TOP") {
        dataToSend.application_status = "WAITING";
        dataToSend.priority = "TOP";
      } else if (action === "PRIORITIZE_HIGH") {
        dataToSend.application_status = "WAITING";
        dataToSend.priority = "HIGH";
      } else {
        dataToSend.application_status = "REJECTED_BY_HR";
      }

      setConfirmationMenu(null); // Close confirmation menu
      await dispatch(updateHRApplicationStatus(dataToSend));
    } else {
      setConfirmationMenu(null); // Close confirmation menu
    }
  };

  const handleApply = async () => {
    const payload = {
      userId: sessionStorage.getItem("userId") || "",
      courseId: selectedCourseData?.course_id,
      status: "APPLIED",
    };

    await dispatch(updateLearnerApplicationStatus(payload));

    setIsSaveModalOpen(false);
    navigate("/learner/applied-trainings");
  };

  useEffect(() => {
    setFilteredCourses(appliedHRCourses);
  }, [appliedHRCourses]);

  useEffect(() => {
    if (id) {
      dispatch(getHRApplications({ course_id: id, status: "HR_APPROVAL" }));
    }
  }, [pathname, dispatch]);
  // Parse and set modal data for events
  const handleOpenModal = (events: string) => {
    // Step 1: Split by "," only outside of "({ })"
    // const eventBlocks = events.split(/(?<=\)}),/); // Match ", " only outside the "({ })"
    const eventBlocks = events.split(/;\s*/);
    const parsedEvents = eventBlocks.map((block) => {
      // Step 2: Split by "({"
      const [eventName, detailsBlock] = block.split("{(");

      // Step 3: Remove closing ")}" and split details inside "({ })" by ","
      const details = detailsBlock
        ?.replace(")}", "")
        ?.split(",")
        .map((item) => item.trim());

      // Step 4: Map details to fields
      const [date, time, mode, location, classroom, ...instructorsBlock] =
        details || [];
      // Step 5: Clean instructors
      // Step 5: Extract and clean instructors
      const instructors = instructorsBlock
        .join(", ") // Join remaining parts to recreate full instructors string
        .replace("Instructors:", "") // Remove the "Instructors:" prefix
        .trim();

      return {
        eventName: eventName?.trim(),
        date: date || null,
        time: time || null,
        mode: mode || null,
        location: location || null,
        classroom: classroom || null,
        instructors: instructors || null,
      };
    });

    setModalData(parsedEvents);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);
  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
    const filteredData = appliedHRCourses.filter((course: any) => {
      return course.user_name.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredCourses(filteredData);
  };

  const handleDownloadDescriptionFile = async () => {
    setIsDownloading(true);
    try {
      const response = await dispatch(
        downloadDescriptionFile({ course_id: selectedCourseData?.course_id })
      );
      if (response.payload && response.payload.demo_file) {
        const fileUrl = response.payload.demo_file.startsWith('//') 
          ? `https:${response.payload.demo_file}` 
          : response.payload.demo_file;
        window.open(fileUrl, "_blank");
      } else {
        showToast(t("No download material for this course"), "info");
      }
    } finally {
      setIsDownloading(false);
    }
  };

  console.log(selectedApplications);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    application: any
  ) => {
    if (e.target.checked) {
      setSelectedApplications((prev) => [...prev, application]);
    } else {
      setSelectedApplications((prev) =>
        prev.filter((item) => item.user_id !== application.user_id)
      );
    }
  };

  const _handleOptionSelect = (action: string) => {
    if (action !== "SELECT_AN_OPTION") {
      _setConfirmationMenu({ action, items: selectedApplications }); // Show confirmation modal with selected items
      setDropdownValue(action);
    }
  };

  const _handleConfirmation = async (confirm: boolean) => {
    if (confirm && _confirmationMenu) {
      const { action, items } = _confirmationMenu;
      setIsLoading(true);

      // Skip items already rejected to avoid sending a no-op REJECTED_BY_HR -> REJECTED_BY_HR transition
      const pendingItems = items.filter(
        (item: any) => item?.application_status !== "REJECTED_BY_HR"
      );

      // Call API for each selected item
      const promises = pendingItems.map(async (item: any) => {
        const dataToSend = {
          course_id: item?.course_id,
          user_id: item?.user_id,
          application_status: "REJECTED_BY_HR",
        };
        await dispatch(updateHRApplicationStatus(dataToSend));
      });

      // Wait for all API calls to complete
      await Promise.all(promises);

      if (selectedApplications.length === appliedHRCourses.length) {
        navigate("/hr/all-trainings", {
          state: { from: "AllTrainings" },
        });
        return;
      }

      setIsLoading(false);
      _setConfirmationMenu(null);
      setSelectedApplications([]); // Clear selected applications
      setDropdownValue("SELECT_AN_OPTION");
    } else {
      _setConfirmationMenu(null); // Close confirmation modal
      setDropdownValue("SELECT_AN_OPTION");
    }
  };

  const isMobileOrTablet = window.innerWidth < 1024; // Checking for mobile/tablet screens

  return (
    <div className="flex flex-col items-start justify-start gap-[2rem]">
      {isMobileOrTablet ? (
        <>
          <TabNavbar
            id=""
            tabs={HR_TABS}
            selectedTabId={1}
            type="Priority Requests"
          />
          <BackButton
            to="/hr/all-trainings"
            state={{ from: "CourseApplications" }}
          />
        </>
      ) : (
        <>
          <BackButton
            to="/hr/all-trainings"
            state={{ from: "CourseApplications" }}
          />
        </>
      )}
      <div className="flex flex-row w-full justify-between items-center group cursor-pointer">
        <div className="flex flex-col w-full">
          <p className="text-2xl font-semibold text-[#961e38]">
            {selectedCourseData?.course_name}
          </p>
          <div className="flex flex-wrap items-center justify-start gap-5 pt-2">
            <p className="text-xs font-semibold flex items-center justify-start gap-2 w-full sm:w-auto">
              <span className="text-[#b5b5b5]">{t("Type")}:</span>
              <span>{selectedCourseData?.category_type ? t(selectedCourseData.category_type) : t("N/A")}</span>
            </p>
            <p className="text-xs font-semibold flex items-center justify-start gap-2 w-full sm:w-auto">
              <span className="text-[#b5b5b5]">{t("Lang")}:</span>
              <span>{selectedCourseData?.training_languages_oc || t("N/A")}</span>
            </p>

            {selectedCourseData?.creation_date && (
              <p className="text-xs font-semibold flex items-center justify-start gap-2 w-full sm:w-auto">
                <span className="text-[#b5b5b5]">{t("Creation Date")}:</span>
                <span>{selectedCourseData?.creation_date}</span>
              </p>
            )}
            {selectedCourseData?.classroom_training_cost && (
              <p className="text-xs font-semibold flex items-center justify-start gap-2 w-full sm:w-auto">
                <span className="text-[#b5b5b5]">
                  {t("Classroom Training Cost")}:
                </span>
                <span>{selectedCourseData?.classroom_training_cost}</span>
              </p>
            )}
            {selectedCourseData?.online_training_cost && (
              <p className="text-xs font-semibold flex items-center justify-start gap-2 w-full sm:w-auto">
                <span className="text-[#b5b5b5]">
                  {t("Online Training Cost")}:
                </span>
                <span>{selectedCourseData?.online_training_cost}</span>
              </p>
            )}
          </div>
        </div>
        {!isMobileOrTablet && <LanguageSelector />}
      </div>
      <div>
        <button
          className="py-1.5 px-5 bg-white uppercase disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ color: "#961e38", border: "1px solid #961e38" }}
          onClick={handleDownloadDescriptionFile}
          disabled={isDownloading}
        >
          {isDownloading ? t("Downloading...") : t("Download Description")}
        </button>
        <p className="text-sm text-[#961e38] mt-4">
          {t("Please note that only 5 Learners can have Priority at a given time.")}
        </p>
      </div>

      <div className="w-full h-full">
        <div className="w-full">
          <SearchWithFilter
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            disabled={loading}
            isApplyForTeam={true}
          />
        </div>

        {/* Mobile/Tablet View */}
        <div className="block md:hidden w-full">
          {loading || isLoading || updateLoading ? (
            <div className="flex items-center w-full justify-center mt-4 mb-4">
              <SpinnerLoader />
            </div>
          ) : filteredCourses?.length > 0 ? (
            filteredCourses.map((item, i) => {
              return (
                <div
                  key={i}
                  className="border border-[#c6c6c6] py-2 text-left bg-[#f3f3f3] mt-2"
                >
                  <div className="px-4 border-b border-[#c6c6c6] pb-2">
                    <div className="flex items-center justify-between w-full">
                      <h3 className="font-[600] pb-2">{t("User")}</h3>
                      <input
                        type="checkbox"
                        onChange={(e) => handleCheckboxChange(e, item)}
                        disabled={item?.application_status === "REJECTED_BY_HR"}
                        className="ml-2"
                      />
                    </div>
                    <p className="text-lg">
                      {item?.first_name || ""} {item?.last_name || ""}
                    </p>
                  </div>
                  <div className="px-4 border-b border-[#c6c6c6] pb-2">
                    <h3 className="font-[600] pb-2">{t("Type")}</h3>
                    <p className="text-lg">{item?.category_type ? t(item.category_type) : ""}</p>
                  </div>
                  <div className="px-4 border-b border-[#c6c6c6] pb-2">
                    <h3 className="font-[600] pb-2">
                      {t("Application Status")}
                    </h3>
                    <p className="text-lg">
                      {STATUS_MAP[item?.application_status]}
                    </p>
                  </div>
                  <div className="px-4 border-b border-[#c6c6c6] pb-2">
                    <h3 className="font-[600] pb-2">{t("Priority")}</h3>
                    <p className="text-lg">
                      {item?.application_priority === "NOT_SET"
                        ? t("No Priority")
                        : item?.application_priority === "TOP"
                        ? t("Second Priority")
                        : t("First Priority")}
                    </p>
                  </div>
                  <div className="px-4 border-b border-[#c6c6c6] pb-2">
                    <h3 className="font-[600] pb-2">{t("Actions")}</h3>
                    <p className="text-lg">
                      {updateLoading && i === menuOpen ? (
                        <div className="flex items-center w-full justify-center">
                          <SpinnerLoader />
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            setMenuOpen(null);
                            setConfirmationMenu(null);
                            setIsSaveModalOpen(false);
                            handleMenuClick(i);
                          }}
                          className="text-gray-500 hover:text-gray-700 focus:outline-none"
                          title={t("More options")}
                        >
                          <FaEllipsisH size={20} />
                        </button>
                      )}
                    </p>
                    {/* Conditional Menu */}
                    {menuOpen === i && (
                      <div
                        ref={menuMobileRef} // Attach the ref to the menu modal
                        className="absolute right-[5rem] z-10 bg-white shadow-md border rounded"
                      >
                        <ul>
                          {item.application_status === "WAITING" &&
                            item.application_priority === "TOP" &&
                            applidCourseMetaData?.total_high_avail > 0 && (
                              <li
                                onClick={() =>
                                  handleOptionSelect("PRIORITIZE_HIGH", item)
                                }
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              >
                                {t("Send to First Priority")}
                              </li>
                            )}
                          {item.application_status === "WAITING" &&
                            item.application_priority === "NOT_SET" &&
                            applidCourseMetaData?.total_top_avail > 0 && (
                              <li
                                onClick={() =>
                                  handleOptionSelect("PRIORITIZE_TOP", item)
                                }
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              >
                                {t("Send to Second Priority")}
                              </li>
                            )}
                          {(item.application_priority === "HIGH" ||
                            item.application_priority === "TOP") &&
                            item.application_status === "WAITING" && (
                              <li
                                onClick={() =>
                                  handleOptionSelect("REMOVE_PRIORITY", item)
                                }
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              >
                                {t("Remove Priority")}
                              </li>
                            )}
                          {item.application_status !== "REJECTED_BY_HR" && (
                            <li
                              onClick={() =>
                                handleOptionSelect("REMOVE_APPLICATION", item)
                              }
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500"
                            >
                              {t("Remove User's Application")}
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                    {/* Confirmation Menu */}
                    {confirmationMenu && confirmationMenu.item === item && (
                      <div
                        ref={confirmationMobileRef}
                        className="absolute right-[11rem] z-20 bg-white shadow-md border rounded"
                      >
                        <p className="px-4 py-2">{t("Are you sure?")}</p>
                        <div className="flex justify-around px-4 py-2">
                          <button
                            onClick={() => handleConfirmation(true)}
                            className="text-green-500 hover:underline"
                          >
                            {t("Yes")}
                          </button>

                          <button
                            onClick={() => handleConfirmation(false)}
                            className="text-red-500 hover:underline"
                          >
                            {t("No")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="w-full text-center py-5">
              {t("No Application Data found for")}{" "}
              {selectedCourseData.course_name}
            </p>
          )}
          <div className="flex w-full items-center justify-end mb-4 mt-4">
            <select
              className="p-2 border"
              disabled={!dropdownEnabled} // Disable dropdown if no items are selected
              onChange={(e) => _handleOptionSelect(e.target.value)}
              value={dropdownValue}
            >
              <option value="SELECT_AN_OPTION" disabled selected>
                {t("Select a Bulk Removal")}
              </option>
              <option value="REMOVE_USER_APPLICATION">
                {t("Remove User's Application")}
              </option>
            </select>
          </div>
          {_confirmationMenu && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-5 rounded-md shadow-lg flex flex-col justify-between items-end w-[90%] sm:w-[500px] h-[auto] max-h-[80vh]">
                <div className="flex flex-col items-start justify-start gap-5 w-full">
                  <h2 className="text-lg font-semibold text-red-600">
                    {t("Confirm Action")}
                  </h2>
                  <p className="mt-2">
                    {t(`Are you sure want to remove these `)}{" "}
                    {_confirmationMenu.items.length} {t(`applications`)} {"?"}
                  </p>
                </div>
                <div className="mt-4 flex justify-end gap-2">
                  <button
                    className="px-4 py-2 bg-blue-500 text-white rounded"
                    onClick={() => _handleConfirmation(true)}
                  >
                    {t("Yes")}
                  </button>
                  <button
                    className="px-4 py-2 bg-red-500 text-white rounded"
                    onClick={() => _handleConfirmation(false)}
                  >
                    {t("No")}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block relative w-full mt-4">
          <div className="overflow-x-auto">
            <div className="flex w-full items-center justify-end mb-4">
              <select
                className="p-2 border"
                disabled={!dropdownEnabled} // Disable dropdown if no items are selected
                onChange={(e) => _handleOptionSelect(e.target.value)}
                value={dropdownValue}
              >
                <option value="SELECT_AN_OPTION" disabled selected>
                  {t("Select a Bulk Removal")}
                </option>
                <option value="REMOVE_USER_APPLICATION">
                  {t("Remove User's Application")}
                </option>
              </select>
            </div>
            <table className="table-fixed w-full border-collapsel">
              <thead className="bg-[#f8f9fa]">
                <tr className="bg-[#A6192E] text-white">
                  <th className="border-b border-[#961e38] py-2 px-4 w-[10%] text-center">
                    {t("Select")}
                  </th>
                  <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                    {t("User")}
                  </th>
                  <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                    {t("Type")}
                  </th>
                  <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                    {t("Application Status")}
                  </th>
                  <th className="border-b border-[#961e38] py-2 px-4 w-[10%] text-center">
                    {t("Priority")}
                  </th>
                  <th className="border-b border-[#961e38] py-2 px-4 w-[10%] text-center">
                    {t("Actions")}
                  </th>
                </tr>
              </thead>
              {/* </table> */}
              {/* <div className="overflow-y-auto max-h-[300px]">
            <table className="table-auto w-full"> */}
              <tbody>
                {loading || isLoading || updateLoading ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="flex items-center w-full justify-center mt-4 mb-4">
                        <SpinnerLoader />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {filteredCourses?.length > 0 ? (
                      // <div className="max-h-[300px] overflow-y-auto w-full">
                      filteredCourses?.map((item: any, i: any) => (
                        <tr key={i}>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-[10%]">
                            <input
                              type="checkbox"
                              onChange={(e) => handleCheckboxChange(e, item)}
                              disabled={
                                item?.application_status === "REJECTED_BY_HR"
                              }
                            />
                          </td>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                            {item?.first_name || ""} {item?.last_name || ""}
                          </td>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                            {item?.category_type ? t(item.category_type) : ""}
                          </td>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                            {STATUS_MAP[item?.application_status]}
                          </td>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-[10%]">
                            {item?.application_priority === "NOT_SET"
                              ? t("No Priority")
                              : item?.application_priority === "TOP"
                              ? t("Second Priority")
                              : t("First Priority")}
                          </td>
                          <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-[10%]">
                            {updateLoading && i === menuOpen ? (
                              <div className="flex items-center w-full justify-center">
                                <SpinnerLoader />
                              </div>
                            ) : (
                              <button
                                onClick={() => {
                                  setMenuOpen(null); // Close menu
                                  setConfirmationMenu(null);
                                  setIsSaveModalOpen(false);
                                  handleMenuClick(i);
                                }}
                                className="text-gray-500 hover:text-gray-700 focus:outline-none"
                                title={t("More options")}
                              >
                                <FaEllipsisH size={20} />
                              </button>
                            )}
                            {/* Conditional Menu */}
                            {menuOpen === i && (
                              <div
                                ref={menuRef} // Attach the ref to the menu modal
                                className="absolute right-0 z-10 bg-white shadow-md border rounded"
                              >
                                <ul>
                                  {item.application_status === "WAITING" &&
                                    item.application_priority === "TOP" &&
                                    applidCourseMetaData?.total_high_avail >
                                      0 && (
                                      <li
                                        onClick={() =>
                                          handleOptionSelect(
                                            "PRIORITIZE_HIGH",
                                            item
                                          )
                                        }
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      >
                                        {t("Send to First Priority")}
                                      </li>
                                    )}
                                  {item.application_status === "WAITING" &&
                                    item.application_priority === "NOT_SET" &&
                                    applidCourseMetaData?.total_top_avail >
                                      0 && (
                                      <li
                                        onClick={() =>
                                          handleOptionSelect(
                                            "PRIORITIZE_TOP",
                                            item
                                          )
                                        }
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      >
                                        {t("Send to Second Priority")}
                                      </li>
                                    )}
                                  {(item.application_priority === "HIGH" ||
                                    item.application_priority === "TOP") &&
                                    item.application_status === "WAITING" && (
                                      <li
                                        onClick={() =>
                                          handleOptionSelect(
                                            "REMOVE_PRIORITY",
                                            item
                                          )
                                        }
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      >
                                        {t("Remove Priority")}
                                      </li>
                                    )}
                                  {item.application_status !==
                                    "REJECTED_BY_HR" && (
                                    <li
                                      onClick={() =>
                                        handleOptionSelect(
                                          "REMOVE_APPLICATION",
                                          item
                                        )
                                      }
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500"
                                    >
                                      {t("Remove User's Application")}
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}
                            {/* Confirmation Menu */}
                            {confirmationMenu &&
                              confirmationMenu.item === item && (
                                <div
                                  ref={confirmationRef}
                                  className="absolute right-0 z-20 bg-white shadow-md border rounded"
                                >
                                  <p className="px-4 py-2">
                                    {t("Are you sure?")}
                                  </p>
                                  <div className="flex justify-around px-4 py-2">
                                    <button
                                      onClick={() => handleConfirmation(true)}
                                      className="text-green-500 hover:underline"
                                    >
                                      {t("Yes")}
                                    </button>

                                    <button
                                      onClick={() => handleConfirmation(false)}
                                      className="text-red-500 hover:underline"
                                    >
                                      {t("No")}
                                    </button>
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      // </div>
                      <tr className="pt-5">
                        <td colSpan={5} className="text-center">
                          {t("No Application Data found for")}{" "}
                          {selectedCourseData.course_name}
                        </td>
                      </tr>
                    )}
                  </>
                )}
                {/* Confirmation Menu */}
                {_confirmationMenu && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-5 rounded-md shadow-lg flex flex-col justify-between items-end w-[90%] sm:w-[500px] h-[auto] max-h-[80vh]">
                      <div className="flex flex-col items-start justify-start gap-5 w-full">
                        <h2 className="text-lg font-semibold text-red-600">
                          {t("Confirm Action")}
                        </h2>
                        <p className="mt-2">
                          {t(`Are you sure want to remove these `)}
                          {_confirmationMenu.items.length} {t(`applications`)}
                          {t(`?`)}
                        </p>
                      </div>
                      <div className="mt-4 flex justify-end gap-2">
                        <button
                          className="px-4 py-2 bg-blue-500 text-white rounded"
                          onClick={() => _handleConfirmation(true)}
                        >
                          {t("Yes")}
                        </button>
                        <button
                          className="px-4 py-2 bg-red-500 text-white rounded"
                          onClick={() => _handleConfirmation(false)}
                        >
                          {t("No")}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </tbody>
            </table>

            <EventDetailsModal
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              modalData={modalData}
            />

            <div className="bg-[#A6192E] w-full text-white h-10 mt-4"></div>
          </div>
        </div>
      </div>
      {isSaveModalOpen && (
        <SaveConfirmModal
          closeModal={() => setIsSaveModalOpen(false)}
          handleSave={handleApply}
          msg="Are you sure you want to apply for this course?"
        />
      )}
    </div>
  );
}

export default CourseApplications;
